<template>
  <div class="shadow card-container">
    <div v-if="forConasi" class="col-sm-12">
      <div class="row voucher-card">
        <div class="col-sm-4 p-2" style="align-self: center;">
          <img :src="voucher.issuanceImage ? voucher.issuanceImage : voucherDefaultImg" alt="" style="width: 100%">
        </div>
        <div v-if="voucher.issuanceType != issuanceType.PROMOTION" class="col-sm-8 p-2 voucher-content">
          <p v-if="voucher.isHidePrice">&emsp;</p>
          <p v-else class="font-weight-bold primary-color">
            {{ voucher.issuanceType === issuanceType.VOUCHER
            ? $t('lookUpVoucher.voucherPrice') : $t('lookUpVoucher.voucherDiscount')}}:
            {{ voucher.issuanceType === issuanceType.VOUCHER 
            ? `${convertToMoney(voucher.value)}  VND` : `${voucher.value} %` }}</p>
          <p>{{ $t('lookUpVoucher.voucherSupplier') }}: {{ voucher.ownerVoucher.name }}</p>
          <p>{{ $t('lookUpVoucher.seriNumber') }}: {{ voucher.serial }}</p>
          <p v-if="voucher.activeCodeQr">{{ $t('lookUpVoucher.expiredDate') }}:
            <span :class="isAlmostExpired(voucher.expiredDate)">{{ voucher.expiredDate }}</span>
          </p>
          <p v-if="isTranferred">{{ $t('lookUpVoucher.fullName') }}: {{ voucher.toUserTransferred.full_name }}</p>
          <p v-if="isTranferred">{{ $t('lookUpVoucher.email') }}: {{ voucher.toUserTransferred.email }}</p>
        </div>
        <div v-else class="col-sm-8 p-2 voucher-content">
          <p class="font-weight-bold primary-color">
            {{ $t('lookUpVoucher.voucherPrice') }}:
            {{ `${convertToMoney(voucher.value)} VND` }}</p>
          <p>{{ $t('lookUpVoucher.voucherSupplier') }}: {{ voucher.owner }}</p>
          <!-- <p>{{ $t('lookUpVoucher.seriNumber') }}: {{ voucher.serial }}</p> -->
          <p>{{ $t('lookUpVoucher.expiredDate') }}:
            <span :class="isAlmostExpired(voucher.expiredDate)">{{ voucher.expiredDate }}</span>
          </p>
          <p v-if="voucher.remainQuantity > 0">{{ $t('evoucher.remainQuantity') }}: <span class="font-weight-bold primary-color">{{ voucher.remainQuantity }}</span></p>
          <p v-else style="color: red;">{{ $t('evoucher.quantityIsOver') }}</p>
        </div>
      </div>
    </div>
    <div v-else>
      <div class="voucher-card">
        <div>
          <img :src="voucher.issuanceImage ? voucher.issuanceImage : voucherDefaultImg" alt="" class="image-avatar">
        </div>
        <div v-if="voucher.issuanceType != issuanceType.PROMOTION" class="voucher-content m-2">
          <p v-if="voucher.isHidePrice">&emsp;</p>
          <p v-else class="font-weight-bold primary-color"><i class="fas fa-tag" style="transform: scaleX(-1);"/>
            {{ voucher.issuanceType === issuanceType.VOUCHER
            ? $t('lookUpVoucher.voucherPrice') : $t('lookUpVoucher.voucherDiscount')}}:
            {{ voucher.issuanceType === issuanceType.VOUCHER 
            ? `${convertToMoney(voucher.value)}  VND` : `${voucher.value} %` }}</p>
          <p class="font-weight-bold">{{ voucher.workpiece.name }}</p>
          <div class="divider-text bg-light"></div>
          <p>{{ $t('lookUpVoucher.voucherSupplier') }}: {{ voucher.ownerVoucher.name }}</p>
          <div class="text-right">
            <p>{{ $t('lookUpVoucher.seriNumber') }}: {{ voucher.serial }}</p>
            <p v-if="voucher.activeCodeQr">{{ $t('lookUpVoucher.expiredDate') }}:
              <span :class="isAlmostExpired(voucher.expiredDate)">{{ voucher.expiredDate }}</span>
            </p>
          </div>
          <div v-if="isTranferred" class="divider-text bg-light"></div>
          <p v-if="isTranferred">{{ $t('lookUpVoucher.fullName') }}: {{ voucher.toUserTransferred.full_name }}</p>
          <p v-if="isTranferred">{{ $t('lookUpVoucher.email') }}: {{ voucher.toUserTransferred.email }}</p>
        </div>
        <div v-else class="voucher-content m-2">
          <p class="font-weight-bold primary-color">
            {{ $t('lookUpVoucher.voucherPrice') }}:
            {{ `${convertToMoney(voucher.value)} VND` }}</p>
          <p class="font-weight-bold">{{ voucher.name }}</p>
          <div class="divider-text bg-light"></div>
          <p>{{ $t('lookUpVoucher.voucherSupplier') }}: {{ voucher.owner }}</p>
          <p>{{ $t('lookUpVoucher.expiredDate') }}:
            <span :class="isAlmostExpired(voucher.expiredDate)">{{ voucher.expiredDate }}</span>
          </p>
          <p v-if="voucher.remainQuantity > 0">{{ $t('evoucher.remainQuantity') }}: <span class="font-weight-bold primary-color">{{ voucher.remainQuantity }}</span></p>
          <p v-else style="color: red;">{{ $t('evoucher.quantityIsOver') }}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import functionUtils from "Utils/functionUtils";
import dateUtils from "Utils/dateUtils";
import { FOR_CONASI_TARGET, NUMBER_OF_ALMOST_EXPIRED_DATE } from 'Utils/constants'
import Enum from "Enum/enum";
import VoucherStatusType from "Enum/voucherStatusType";
export default {
  props: ['voucher', 'isTranferred'],
  data: () => ({
    voucherDefaultImg: Enum.Evoucher_Img_Default,
    issuanceType: Enum.issuanceType,
    VoucherStatusType: VoucherStatusType,
    forConasi: FOR_CONASI_TARGET
  }),
  methods: {
    /**
     * Convert to money
     */
    convertToMoney: function(value) {
      return functionUtils.convertFormatNumberToMoney(value);
    },
    isAlmostExpired: function (endDate) {
      if (this.voucher.status != this.VoucherStatusType.USED) {
        var days = dateUtils.getRemainDays(endDate)
        return (days <= NUMBER_OF_ALMOST_EXPIRED_DATE) ? 'almost-expired' : ''
      }
      return ''
    }
  }
};
</script>

<style lang="scss" scoped>
@import "@/styles/color.scss";
.shadow {
  -moz-box-shadow: inset 1 1 20px #000000;
  -webkit-box-shadow: inset 1 1 20px #000000;
  box-shadow: inset 1 1 20px #000000;
}
.card-container {
  height: 100%;
  min-height: 100px;
  border: 1px solid #e5e5e5;
  align-items: center;
  justify-content: center;
  align-items: center;
  border-radius: 7px;
}
.image-avatar {
  border-radius: 7px;
  width: 100%;
}
.voucher-card {
  font-family: "Roboto", "Arial", "Helvetica", "sans-serif";
}
.voucher-content p{
  margin-bottom: 0;
  word-break: break-all;
}
.divider-text {
  position: relative;
  text-align: center;
  margin: .5em 0 1em 0;
}
.divider-text:after {
  content: "";
  position: absolute;
  width: 100%;
  border-bottom: 1px solid #ddd;
  top: 55%;
  left: 0;
  z-index: 1;
}
.almost-expired {
  font-weight: 700;
  color: red;
}
</style>
